import { SanityImage } from '@/shared/types/sanity';

export type SanityImageMeta = {
  image: SanityImage;
  alt?: string;
  source?: string;
  sourceUrl?: string;
};

/** Image served as a plain URL (from REST API, no Sanity builder needed). */
export type UrlImageMeta = {
  imageUrl: string;
  alt?: string;
  source?: string;
  sourceUrl?: string;
};

export type ImageMeta = SanityImageMeta | UrlImageMeta;

export function isSanityImage(image: ImageMeta): image is SanityImageMeta {
  return 'image' in image;
}
